function labeledContentProps(props) {
  var { label, value, systemImage, hasChildren } = props;
  if (typeof label !== "string" || !label) throw new Error("Swift.LabeledContent label must be a non-empty string");
  if (value !== void 0 && typeof value !== "string") throw new Error("Swift.LabeledContent value must be a string");
  if (systemImage !== void 0 && typeof systemImage !== "string") throw new Error("Swift.LabeledContent systemImage must be a string");
  if (value !== void 0 && hasChildren) throw new Error("Swift.LabeledContent takes either a value or children");
  if (value === void 0 && !hasChildren) throw new Error("Swift.LabeledContent needs a value or children");
  return {
    label,
    value: value !== null && value !== void 0 ? value : "",
    systemImage: systemImage !== null && systemImage !== void 0 ? systemImage : ""
  };
}
export {
  labeledContentProps
};
//# sourceMappingURL=labeledContent.js.map
